import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { ButtonWithDialog } from "../button_with_dialog/button_with_dialog";
import { LoadWrapper } from "../load_wrapper";
import useUserPrivacyHistory from "./hooks/useUserPrivacyHistory";

const ReadonlyCheckbox = ({ v }: { v: boolean }) => (
  <Checkbox readOnly checked={v} />
);

export type UserPrivacyHistoryProps = {
  userId: string;
};
export default function UserPrivacyHistory(props: UserPrivacyHistoryProps) {
  const { userId } = props;
  const { error, loading, userPrivacyHistory } = useUserPrivacyHistory(userId);

  return (
    <LoadWrapper loading={loading} error={error}>
      <TableContainer component={Paper}>
        <Table
          style={{ width: "100%" }}
          size="small"
          aria-label="Elenco privacy utente"
        >
          <TableHead>
            <TableRow>
              <TableCell>data</TableCell>
              <TableCell>Consenso base</TableCell>
              <TableCell>Consenso marketing</TableCell>
              <TableCell>Consenso cessione dati a terzi</TableCell>
              <TableCell>Consenso dati personali</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {userPrivacyHistory?.map((p) => (
              <TableRow key={p.lastUpdate}>
                <TableCell component="th" scope="row">
                  {new Date(p.lastUpdate).toLocaleString()}
                </TableCell>
                <TableCell>
                  <ReadonlyCheckbox v={p.basicPolicyAccepted} />
                </TableCell>
                <TableCell>
                  <ReadonlyCheckbox v={p.newsletterAccepted} />
                </TableCell>
                <TableCell>
                  <ReadonlyCheckbox v={p.thirdPartyDataTransmissionAccepted} />
                </TableCell>
                <TableCell>
                  <ReadonlyCheckbox
                    v={p.userPersonalDataTransmissionAccepted}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </LoadWrapper>
  );
}

export function UserPrivacyHistoryWithDialogButton(
  props: UserPrivacyHistoryProps
) {
  return (
    <ButtonWithDialog
      buttonProps={{
        variant: "contained",
        children: <Typography variant="button">Storico consensi</Typography>,
      }}
      dialogProps={{
        fullScreen: false,
        title: "Storico consensi",
      }}
    >
      <UserPrivacyHistory {...props} />
    </ButtonWithDialog>
  );
}
